//src/api/kanban.js
import request from '@/utils/request'
export default {
    daily() {
        return request.get('/kanban/daily');
    }
}


